import { useEffect, useState } from 'react';
import { getAllReturns, updateReturn } from '../../services/api';
import toast from 'react-hot-toast';

const statusColors = {
  requested: 'bg-yellow-100 text-yellow-700',
  approved:  'bg-blue-100 text-blue-700',
  rejected:  'bg-red-100 text-red-700',
  received:  'bg-purple-100 text-purple-700',
  refunded:  'bg-green-100 text-green-700',
};

export default function AdminReturns() {
  const [returns, setReturns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllReturns().then(r => setReturns(r.data)).finally(() => setLoading(false));
  }, []);

  const handleStatus = async (id, status) => {
    try {
      await updateReturn(id, { status });
      setReturns(prev => prev.map(r => r._id === id ? { ...r, status } : r));
      toast.success('Return status updated');
    } catch {
      toast.error('Update failed');
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 className="font-display text-4xl font-bold text-yamass-black mb-8">Returns</h1>

      {loading ? (
        <div className="space-y-3">{[...Array(4)].map((_, i) => <div key={i} className="skeleton h-24 rounded-xl" />)}</div>
      ) : returns.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-gray-400 text-lg">No return requests yet</p>
        </div>
      ) : (
        <div className="space-y-4">
          {returns.map(ret => (
            <div key={ret._id} className="bg-yamass-cream rounded-2xl p-5">
              <div className="flex items-start justify-between gap-4 flex-wrap">
                <div>
                  <p className="text-xs text-gray-400 mb-1">
                    Return #{ret._id.slice(-6).toUpperCase()} ·{' '}
                    {new Date(ret.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </p>
                  <p className="font-semibold text-yamass-black text-sm">{ret.user?.name} — {ret.user?.email}</p>
                  <p className="text-sm text-gray-500 mt-1">Reason: {ret.reason}</p>
                  {ret.description && <p className="text-xs text-gray-400 mt-0.5">{ret.description}</p>}
                </div>
                <div className="flex items-center gap-3">
                  <select
                    value={ret.status}
                    onChange={e => handleStatus(ret._id, e.target.value)}
                    className={`text-xs font-medium px-3 py-1.5 rounded-full border-0 cursor-pointer focus:outline-none focus:ring-2 focus:ring-yamass-accent ${statusColors[ret.status]}`}
                  >
                    {['requested','approved','rejected','received','refunded'].map(s => (
                      <option key={s} value={s} className="bg-white text-gray-700">{s}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Items */}
              <div className="flex gap-3 mt-4 flex-wrap">
                {ret.items?.map((item, i) => (
                  <div key={i} className="flex items-center gap-2 bg-white rounded-xl px-3 py-2">
                    <span className="text-sm">👕</span>
                    <div>
                      <p className="text-xs font-medium text-yamass-black">{item.name}</p>
                      <p className="text-xs text-gray-400">Size: {item.size} · ৳{item.price}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex items-center gap-2 mt-3 text-xs text-gray-400">
                <span>Refund via: <span className="font-medium text-yamass-black capitalize">{ret.refundMethod}</span></span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
